<template>
  <div>
    <Layout ref="layoutRef" :selectedOption="3" />
    <div class="mb-3">
      <div class="row">
        <div class="col-11">
          <h4>Paquetes de exámenes</h4>
        </div>
        <div class="col-1">
          <button
            class="btn-help"
            type="button"
            title="Abrir ayuda"
            @click="showModalHelp = true"
            aria-label="Abrir ayuda de paquetes"
          >
            <span class="material-symbols-outlined">help</span>
          </button>
        </div>
      </div>
    </div>
<!--
    <Modal v-model:modelValue="showModalHelp" title="Ayuda — Paquetes de exámenes">
      <AyudaPaquete />
    </Modal>
-->
    <hr>

    <!--  DataTable  -->
    <DataTable
      :data="paquetes"
      :columns="columnas"
      idField="idPaquete"
      :acciones="true"
      :mostrarBotonTodos="true"
      :mostrarBotonNuevo="true"
      :mostrarBotonExcel="false"
      :mostrarInfo="false"
      :mostrarEditar="true"
      :mostrarVer="false"
      :mostrarEliminar="true"
      mensajeVacio="Sin registros de paquetes."
      @refresh="cargarPaquetes()"
      @create="abrirNuevo()"
      @edit="({ idPaquete }) => editarPorId(idPaquete)"
      @delete="({ idPaquete }) => confirmarEliminar(idPaquete)"
    >
      <template #cell-tipo="{ row }">
        {{ labelTipo(row.tipo) }}
      </template>
      <template #cell-cantidadExamenes="{ row }">
        {{ row.detalles?.length ?? 0 }}
      </template>
      <template #cell-estado="{ row }">
        <span :class="row.estado === 1 ? 'badge-activo' : 'badge-inactivo'">
          {{ row.estado === 1 ? 'Activo' : 'Inactivo' }}
        </span>
      </template>
    </DataTable>

    <!--  Modal crear / editar  -->
    <div class="modal fade" id="modalPaquete" tabindex="-1" aria-labelledby="modalPaqueteLabel" aria-hidden="true" v-if="modalWindow">
      <div class="modal-dialog modal-xl">
        <div class="modal-content">

          <div class="modal-header bg-primary">
            <h5 class="modal-title text-white" id="modalPaqueteLabel">
              {{ form.idPaquete ? 'Editar' : 'Nuevo' }} paquete
            </h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal" aria-label="Cerrar"></button>
          </div>

          <div class="modal-body">
            <!-- Nombre -->
            <div class="row mb-2">
              <div class="col-3"><label class="fw-bold">Nombre *</label></div>
              <div class="col-9">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="form.nombre"
                  placeholder="Ej. Control niño sano"
                  style="text-transform:uppercase"
                />
              </div>
            </div>

            <!-- Tipo -->
            <div class="row mb-2">
              <div class="col-3"><label class="fw-bold">Tipo</label></div>
              <div class="col-9">
                <select class="form-select form-select-sm" v-model="form.tipo">
                  <option value="">-- Seleccionar --</option>
                  <option value="NINO_SANO">Control niño sano</option>
                  <option value="ESCOLAR">Control escolar</option>
                  <option value="ADULTO">Control adulto</option>
                  <option value="OTRO">Otro</option>
                </select>
              </div>
            </div>

            <!-- Descripción -->
            <div class="row mb-2">
              <div class="col-3"><label class="fw-bold">Descripción</label></div>
              <div class="col-9">
                <textarea class="form-control form-control-sm" v-model="form.descripcion" rows="2"></textarea>
              </div>
            </div>

            <!-- Buscador de exámenes -->
            <div class="row mb-2">
              <div class="col-3"><label class="fw-bold">Buscar examen</label></div>
              <div class="col-9">
                <input
                  type="text"
                  class="form-control form-control-sm"
                  v-model="busquedaExamen"
                  placeholder="Filtrar por nombre..."
                  @input="filtrarExamenes()"
                  style="text-transform:uppercase"
                />
              </div>
            </div>

            <!-- Lista de exámenes -->
            <div class="row mb-1">
              <div class="col-3">
                <label class="fw-bold">Exámenes</label>
                <p class="text-muted" style="font-size:11px; margin-top:4px;">
                  {{ examenesSeleccionados.length }} seleccionado(s)
                </p>
              </div>
              <div class="col-9">
                <div class="exam-list border rounded p-2">
                  <label
                    v-for="ex in examensFiltrados"
                    :key="ex.idExamen"
                    class="exam-item d-flex align-items-center gap-2 py-1"
                    style="font-size:13px; cursor:pointer;"
                  >
                    <input type="checkbox" :value="ex.idExamen" v-model="examenesSeleccionados" />
                    {{ ex.nombre }}
                  </label>
                  <p v-if="!examensFiltrados.length" class="text-muted mb-0" style="font-size:12px;">
                    Sin resultados
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cancelar
            </button>
            <button type="button" class="btn btn-primary" :disabled="guardando" @click="guardar()">
              <span v-if="guardando" class="spinner-border spinner-border-sm me-1" role="status"></span>
              {{ guardando ? 'Guardando...' : 'Guardar' }}
            </button>
          </div>

        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import Layout      from '@/components/Layout.vue'
import Footer      from '@/components/Footer.vue'
import DataTable   from '@/components/DataTable.vue'
import { paqueteService, examenService } from '@/services/paqueteService'
import { openModal, closeModal } from '@/modules/modalHelper.js'
import swal2 from 'sweetalert2'

const TIPOS = {
  NINO_SANO: 'Control niño sano',
  ESCOLAR:   'Control escolar',
  ADULTO:    'Control adulto',
  OTRO:      'Otro',
}

export default {
  name: 'PaqueteView',
  components: { Layout, Footer, DataTable },

  data() {
    return {
      paquetes:              [],
      examenes:              [],
      examensFiltrados:      [],
      busquedaExamen:        '',
      examenesSeleccionados: [],
      modalWindow:           true,
      guardando:             false,
      showModalHelp:         false,
      form: {
        idPaquete:   null,
        nombre:      '',
        tipo:        '',
        descripcion: '',
      },
columnas: [
  { field: 'idPaquete',        label: '#' },
  { field: 'nombre',           label: 'Nombre' },
  {
    field: 'tipo',
    label: 'Tipo',
    filterType: 'select',
    filterOptions: [
      { label: 'Control niño sano', value: 'NINO_SANO' },
      { label: 'Control escolar',   value: 'ESCOLAR'   },
      { label: 'Control adulto',    value: 'ADULTO'    },
      { label: 'Otro',              value: 'OTRO'      },
    ],
  },
  { field: 'cantidadExamenes', label: 'Exámenes' },
  {
    field: 'estado',
    label: 'Estado',
    filterType: 'select',
    filterOptions: [
      { label: 'Activo',   value: 1 },
      { label: 'Inactivo', value: 0 },
    ],
  },
],
    }
  },

async mounted() {
  this.$refs.layoutRef.toggleProcesos()
  this.$refs.layoutRef.toggleReportes()
  this.$refs.layoutRef.toggleParametros()
  this.$refs.layoutRef.toggleAyuda()

  await this.cargarPaquetes()

  const { data } = await examenService.listar()
  console.log('Exámenes recibidos:', data)
  this.examenes         = data
  this.examensFiltrados = data
},

  methods: {
    labelTipo(t) { return TIPOS[t] ?? t ?? '—' },

    //  Carga
    async cargarPaquetes() {
      const { data } = await paqueteService.listar()
      this.paquetes = data
    },

    //  Filtro exámenes
    filtrarExamenes() {
      const q = this.busquedaExamen.toLowerCase()
      this.examensFiltrados = q
        ? this.examenes.filter(e => e.nombre.toLowerCase().includes(q))
        : this.examenes
    },

    //  Nuevo
abrirNuevo() {
  this.form = { idPaquete: null, nombre: '', tipo: '', descripcion: '' }
  this.examenesSeleccionados = []
  this.busquedaExamen        = ''
  this.examensFiltrados      = [...this.examenes]
  this.$nextTick(() => openModal('modalPaquete'))
},

    //  Editar
async editarPorId(idPaquete) {
  const { data } = await paqueteService.obtener(idPaquete)
  this.form = {
    idPaquete:   data.idPaquete,
    nombre:      data.nombre,
    tipo:        data.tipo        ?? '',
    descripcion: data.descripcion ?? '',
  }
  this.examenesSeleccionados = (data.detalles ?? []).map(d => d.idExamen)
  this.busquedaExamen        = ''
  this.examensFiltrados      = [...this.examenes]
  this.$nextTick(() => openModal('modalPaquete'))
},

    //  Guardar
    async guardar() {
      if (!this.form.nombre.trim()) {
        swal2.fire('Validación', 'El nombre es obligatorio.', 'warning')
        return
      }
      this.guardando = true
      try {
        const payload = {
          ...this.form,
          estado:   1,
          detalles: this.examenesSeleccionados.map(id => ({
            idExamen:    id,
            obligatorio: true,
          })),
        }
        if (this.form.idPaquete) {
          await paqueteService.actualizar(this.form.idPaquete, payload)
        } else {
          await paqueteService.crear(payload)
        }
        await this.cargarPaquetes()
        closeModal('modalPaquete')
        swal2.fire('Correcto', 'Paquete guardado exitosamente.', 'success')
      } catch (e) {
        swal2.fire('Error', 'Error al guardar: ' + (e.response?.data?.message ?? e.message), 'error')
      } finally {
        this.guardando = false
      }
    },

    //  Eliminar
    async confirmarEliminar(idPaquete) {
      const result = await swal2.fire({
        title:             '¿Eliminar paquete?',
        text:              'Se realizará una baja lógica.',
        icon:              'warning',
        showCancelButton:  true,
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText:  'Cancelar',
      })
      if (!result.isConfirmed) return
      try {
        await paqueteService.eliminar(idPaquete)
        await this.cargarPaquetes()
        swal2.fire('Correcto', 'Paquete eliminado.', 'success')
      } catch (e) {
        swal2.fire('Error', 'No se pudo eliminar.', 'error')
      }
    },
  },
}
</script>

<style src="@/assets/css/listaRegistros.css" scoped></style>
<style scoped>
.badge-activo   { background:#d1fae5; color:#065f46; padding:2px 8px; border-radius:12px; font-size:12px; }
.badge-inactivo { background:#fee2e2; color:#991b1b; padding:2px 8px; border-radius:12px; font-size:12px; }
.exam-list      { max-height:200px; overflow-y:auto; }
</style>